import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-dashboard',
    templateUrl: './full-layout.component.html'
})
export class FullLayout implements OnInit {
    ngOnInit(): void { }
}



// WEBPACK FOOTER //
// /app/src/app/containers/full-layout/full-layout.component.ts